import { useEffect, useState } from "react";

/**
 * Reactive `window.matchMedia` wrapper used to drive responsive prop choices
 * (e.g. collapse button labels to icons below the `md` breakpoint).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    // Safari < 14 has only the deprecated addListener API.
    if (!mq.addEventListener) {
      mq.addListener(handler);
      return () => mq.removeListener(handler);
    }
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [query]);

  return matches;
}
